































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import HotkeyListener from '@/layouts/gripper/hotkeys/HotkeyListener.vue';

@Component({
    components: {HotkeyListener},
  })
  export default class PaginateButtonsWithMin extends Vue {

    @Prop({default: true}) public canChangePage?: boolean;
    @Prop(Number) public minId?: number;
    @Prop(Number) public currentPage!: number;
    @Prop(Number) public totalPages!: number;

    private pageSelection: number = this.currentPage;

    @Watch('pageSelection')
    public pageChange(origin: KeyboardEvent['key'] | string | number) {
      if (origin === 'previous' || origin === 'PageDown' && this.currentPage > 1) {
        this.$emit('onPageChangeEvent', this.currentPage - 1);
      } else if (origin === 'next' || origin === 'PageUp') {
        this.$emit('onPageChangeEvent', this.currentPage + 1);
      } else if (typeof origin === 'number') {
        this.$emit('onPageChangeEvent', origin);
      }
    }
  }
